import { Box } from '@mui/material';
import { FC } from 'react';
import { useRequestDetailsView } from '../../../../hooks/use-request-details-view';
import { GeneralPatientInfo } from '../../../../shared/general-patient-info/general-patient-info';
import { LabeledText } from '../../../../shared/labeled-text/labeled-text';
import { IvStatus } from './iv-status/iv-status';

export const PatientDetailsSection: FC = (props) => {
  const { requestDetails, contact } = useRequestDetailsView();

  return (
    <>
      <GeneralPatientInfo requestDetails={requestDetails} contact={contact} />
      <Box sx={{ margin: '0 25px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <LabeledText label="Type">{requestDetails.appointmentType}</LabeledText>
          <LabeledText label="Source" sx={{ marginLeft: '20%' }}>
            {requestDetails.sourceTypeDisplay ?? 'Unknown'}
          </LabeledText>
        </Box>
        <LabeledText label="Comment">
          {requestDetails.comment || requestDetails.patientNote
            ? requestDetails.comment || requestDetails.patientNote
            : 'No comments'}
        </LabeledText>
        <IvStatus />
      </Box>
    </>
  );
};
